import React from 'react';
import EditBookComponent from '../../components/EditBookComponent/EditBookComponent';

function EditBookPage() {
  return <EditBookComponent />;
}

export default EditBookPage;
